import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getPrNewsById } from '../../../api/nexus';
import MiDetailLayout, {
  MiDetailError,
  MiDetailLoading,
} from '../../../components/mi/MiDetailLayout';
import NewsArticleView from '../components/NewsArticleView';
import { formatTableDate } from '../../../utils/intelAxisTableUtils';

export default function NewsPrDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getPrNewsById(id)
      .then((res) => {
        if (cancelled) return;
        setArticle(res?.data?.data || null);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || 'Failed to load article');
        setArticle(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const backPath = sessionStorage.getItem('comply_last_news_pr_path') || '/news-pr';

  if (loading) {
    return <MiDetailLoading message="Loading article…" />;
  }

  if (error || !article) {
    return (
      <MiDetailError
        message={error || 'Article not found.'}
        backLabel="Back to News / PR"
        onBack={() => navigate(backPath)}
      />
    );
  }

  const newsDate = formatTableDate(article.dateOfNews);
  const subtitleParts = [article.company, newsDate].filter(Boolean);

  return (
    <div className="mi-detail-page--news-article">
      <MiDetailLayout
        backLabel="Back to News / PR"
        onBack={() => navigate(backPath)}
        title={article.headline || 'News / PR item'}
        subtitle={subtitleParts.join(' · ')}
      >
        <NewsArticleView article={article} />
      </MiDetailLayout>
    </div>
  );
}
